import FullScreenLoader from "components/Feed/FullScreenLoader";
import React from "react";
import { ToastContainer } from "react-toastify";
import MyRouter from "routers/index";

function App() {
  return (
    <div className="bg-white text-base dark:bg-neutral-900 text-neutral-900 dark:text-neutral-200 min-h-screen flex flex-col">
      <ToastContainer />
      <FullScreenLoader />
      <MyRouter />
    </div>
  );
}

export default App;
